import { Button, Column, Columns, Detail, Flex, Text } from "@dna/react";
import { FormControl, Box, TextField, CircularProgress } from "@material-ui/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useAsync } from "../common/async";
import styles from "./SelectOrganisation.module.scss";
import { organisationService } from "../../services/organisation/OrganisationApi";
import { LoadingPlaceholder } from "@communicare/medications/Components/Placeholder";
import { FlatButton } from "../common/FlatButton";
import { Autocomplete } from "@material-ui/lab";
import { RadioButtonGroup } from "../common/radio-button-group";
import { MapUserToExternalUserType } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { FormControlContainer } from "../register-user/FormControlContainer";
import { useForm } from "react-hook-form";
import { RenderIf } from "../common/render-if/RenderIf";
import { tokenToString } from "typescript";
import { isNullOrUndefinedOrEmptyString } from "../common/utils/util";
import { TextFieldComponent } from "../shared-user/common/TextFieldComponent";
import { IMapUserToExternalUser } from "../../services/medicationmanagement/userRegistration/models/MapUserToExternalUser";
import { yupResolver } from "@hookform/resolvers/yup";
import { PrescriberSchema, PharmacistSchema } from "./Schema/MapUserToExternalUser";
import { getUserAttempts, mapUsers } from "../../services/medicationmanagement/userRegistration/userRegistraitionService";
import { WarningBanner } from "../layout/WarningBanner";
import { SuccessBanner } from "../layout/SuccessBanner";
import { handleSignOut } from "../common/handleSignOut";
import { saveUserAttempts } from "../../services/medicationmanagement/userRegistration/userRegistraitionService";
import cx from 'classnames';
import { MessageType } from "../common/constants";
import { MapExternalUserMessageBox } from "./MapExternalUserMessageBox";
export enum UserLinkingStatus {
    SendRequest,
    Success,
    Failure
  }

  export interface MapUserToExternalUserProps {
    userId: string;
    isAnotherProvider: boolean;
  }
  
  const createOptions =()=> { 
    return [
      {
        code: MapUserToExternalUserType.Prescriber.toString(),
        desc: "Prescriber"
    },
    {
        code: MapUserToExternalUserType.Pharmacist.toString(),
        desc: "Pharmacist"
    }];
};

  export function MapUserToExternalUser({userId, isAnotherProvider}:MapUserToExternalUserProps) {
    let { inProgress, success, error, queryDispatcher } = useAsync();
    const [userTypeValue, setUserTypeValue] = useState(null);
    const [registrationStatus, setRegistrationStatus] = useState(UserLinkingStatus.SendRequest);
    const [isPrescriberSelected, setIsPrescriberSelected] = useState(false);
    const [organisationNames, setOrganisationNames] = useState([]);
    const [reviewAttempts, setReviewAttempts] = useState(0);
    const [warningMessageTitle, setWarningMessageTitle] = useState("We can't find you.");
    const [warningMessageBody, setWarningMessageBody] = useState("Please review your details or contact the aged care facility.");
    const [isLoading, setIsLoading] = useState(true);
    const renderRef = useRef(true);
    let userTypeOptions = createOptions();
    let formRef = useRef(null);

    const formUtils = useForm<IMapUserToExternalUser>({
      resolver: yupResolver(
        isPrescriberSelected ? PrescriberSchema : PharmacistSchema
      ),
      mode: "onChange"
    });
   
    const {register, control, formState: { errors }, resetField, handleSubmit, watch} = formUtils;

    let providerNumberValue = watch("providerNumber");
    let prescriberNumberValue = watch("prescriberNumber");
    let hpiiNumber = watch("hpiiNumber");
    const hasEmptyField = 
    isPrescriberSelected && (
    isNullOrUndefinedOrEmptyString(prescriberNumberValue) ||
    isNullOrUndefinedOrEmptyString(hpiiNumber)
    )
    ||
    (!isPrescriberSelected && (isNullOrUndefinedOrEmptyString(hpiiNumber)));

    const hasErrors = !isNullOrUndefinedOrEmptyString(errors.hpiiNumber) || !isNullOrUndefinedOrEmptyString(errors.prescriberNumber) ;
    const onUserTypeChange = (val: any) => {
      setUserTypeValue(val);
      if(val === MapUserToExternalUserType.Prescriber.toString()){
        setIsPrescriberSelected(true);
      }
      else {
        setIsPrescriberSelected(false);
      }
      resetField('hpiiNumber'); 
      resetField('prescriberNumber');
  };

  const setRetryLimitReachedForm = () => {
    setWarningMessageTitle("Maximum retry limit reached.");
    setWarningMessageBody("Please wait 30 minutes before trying again.");
  }

  const saveRetryLimitReached = () => {
    saveUserAttempts()
    .then(result => {
      setRetryLimitReachedForm();
      setIsLoading(false);
    })
    .catch(error => {
      setIsLoading(false);
    })
  }

  const onSubmit = (data: IMapUserToExternalUser) => {  
    let formattedData = {
        ...data,
        mappingUserType: userTypeValue == 0 ? 0 : 1
    };
    setIsLoading(true);
    mapUsers(formattedData)
        .then(result => {
          setIsLoading(false);
          if(!isNullOrUndefinedOrEmptyString(result.organisationList)){
             setOrganisationNames(result.organisationList.split(','));
            setRegistrationStatus(UserLinkingStatus.Success);
          }
          else {
            setRegistrationStatus(UserLinkingStatus.Failure);
            if (reviewAttempts === 3){
              //save data in database as attempt limit reached
              setIsLoading(true);
              saveRetryLimitReached();
            }
          }
        })
        .catch(error => {
          setIsLoading(false);
          setRegistrationStatus(UserLinkingStatus.Failure);
        });
  };

  const redirectToHome = () => {
    window.location.href = window.location.origin + "/residents";
  };

  const redirectToLogin = () => {
    handleSignOut({reason: "User mapping failed", url: window.location.href})
  }

  const reviewDetails = () => {
    let retries = reviewAttempts + 1;
    setReviewAttempts(retries);
    setRegistrationStatus(UserLinkingStatus.SendRequest);
  }
 useEffect(() => {
  const firstRender = renderRef.current;
  if (firstRender) {
    renderRef.current = false;
    // Fetch existing user mapping attempts from database to display proper message
    getUserAttempts()
    .then(result => {
      if(!result.attemptRetriesExpired){
          setRegistrationStatus(UserLinkingStatus.Failure);
          setReviewAttempts(3);
          setRetryLimitReachedForm();
      }
      setIsLoading(false);
    })
    .catch(error => {
      setIsLoading(false);
    })
  }
 }); 

    if (isLoading) {
        return (
          <div className={cx(styles.background, styles.noOverflow)}>
            <div className={styles.inner}>
              <Box
                className={styles.content}>
               <CircularProgress
                style={{
                    color: "var(--dna-alias-color-primary)",
                    verticalAlign:"middle",
                    marginLeft: '50%'
                }}
                size={30}
              />
              </Box>
            </div>
          </div>
        );
      }

    return(
        <form ref={formRef} onSubmit = {handleSubmit(onSubmit)} noValidate className={styles.noOverflow}>
        <div className={styles.background}>
          <div className={styles.registrationInner}>
          <FormControl className={styles.fullWidth}>
              <Flex
                css={{
                  gap: "small",
                  padding: 0,
                }}
              >
          { 
        registrationStatus  == UserLinkingStatus.SendRequest &&
        (
          <React.Fragment>
            <div className={styles.contentWidth80}>
              <div>
                <div className={styles.header}>
                  Please complete your registration details
                </div>
                <div className={styles.contentWidth70}>
                <p>
                <RadioButtonGroup
                value={userTypeValue}
                options={userTypeOptions}
                controlLabel="User type"
                nameField="desc"
                valueField="code"
                onChange={onUserTypeChange}
                dataQa="userType"
                />
                <p></p>
                 <RenderIf if={!isNullOrUndefinedOrEmptyString(userTypeValue)}> 
                  <React.Fragment>
                      <TextFieldComponent
                            label="HPI-I number"
                            id="hpiiNumber"
                            register={register}
                            maxLength={16}
                            errors={errors}
                            fontSize={16}
                      />
                    <RenderIf if={isPrescriberSelected}>
                    <React.Fragment>
                          <TextFieldComponent
                              label="Prescriber number"
                              id="prescriberNumber"
                              register={register}
                              errors={errors}
                              maxLength={7}
                              fontSize={16}
                          />
                    </React.Fragment>
                    </RenderIf>
                  </React.Fragment>
                 </RenderIf> 
                </p>
                </div>
              </div>
            </div>
            <hr className={styles.divider} />

            <FlatButton
              type="submit"
              kind="primary"
              isDisabled={isNullOrUndefinedOrEmptyString(userTypeValue) || hasEmptyField || hasErrors}
              css={{
                width: 110,
                alignSelf: "flex-end",
                marginBottom:15,
                marginEnd:15,
              }}
            >
              OK
            </FlatButton>
            </React.Fragment>
          )
      }

      {
        registrationStatus == UserLinkingStatus.Failure && (
          <MapExternalUserMessageBox 
              type={MessageType.Warning} 
              titleText={warningMessageTitle} 
              bodyText={warningMessageBody} 
              isRegistrationForm={true}
              onClose={redirectToLogin} 
              onReviewClick={reviewDetails}
              reviewAttempts={reviewAttempts}
              />
        )
        }

        {
          registrationStatus  == UserLinkingStatus.Success && (
            <MapExternalUserMessageBox 
            type={MessageType.Success} 
            titleText="We found you!" 
            bodyText="You can now access your residents at..." 
            organisationNames={organisationNames}
            redirectToHome = {redirectToHome} 
            isRegistrationForm={true}/>
          )
        } 
       </Flex>
      </FormControl>
      </div>
     </div>
    </form>
  );
}


